import React, { useState } from 'react';

import Button from '@mui/material/Button';
import InfoModal from 'components/SharedComponents/Modals/InfoModal';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

type ScopesProtectionsInfoModalButtonProps = {
    modalContent: string;
    buttonTitle: string;
    modalTitle: string;
};

export const ScopesProtectionsInfoModalButton = ({
    modalContent,
    buttonTitle,
    modalTitle,
}: ScopesProtectionsInfoModalButtonProps): React.ReactElement => {
    const theme = useTheme();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <Button
                onClick={openModal}
                variant="outlined"
                disableElevation
                sx={{
                    border: 'none',
                    background: theme.palette.lightGrey,
                }}
            >
                {buttonTitle}
            </Button>

            <InfoModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={modalTitle}
            >
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                    {modalContent}
                </Typography>
            </InfoModal>
        </>
    );
};
